var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contentIndex',{attrs:{"initInfo":_vm.info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }